import axios from "axios";
import { buildApiUrl } from "./client";

const pendingHistoryRequests = new Map();

const dateKey = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toISOString().slice(0, 10);
};

export const getTicketHistory = ({ role, id, startDate, endDate }) => {
  const key = [role, id, dateKey(startDate), dateKey(endDate)].join("|");
  const pendingRequest = pendingHistoryRequests.get(key);
  if (pendingRequest) return pendingRequest;

  const request = axios.get(
    buildApiUrl(`tickets/historical/${startDate}/${endDate}`),
    { params: { role, id } }
  );
  pendingHistoryRequests.set(key, request);

  const clearPendingRequest = () => {
    if (pendingHistoryRequests.get(key) === request) {
      pendingHistoryRequests.delete(key);
    }
  };
  request.then(clearPendingRequest, clearPendingRequest);

  return request;
};

export const clearPendingTicketHistoryRequests = () => {
  pendingHistoryRequests.clear();
};
